import React from "react"
import { Box } from "@mui/material"
import PropTypes from "prop-types"
import InfoDataPanel from "src/v2/components/InfoDataPanel/info-data-panel"

const gridColumns = { xxxs: 12, xs: 12, md: 12, lg: 12 }
const compactItemGridProps = { xxxs: 12, xs: 6, md: 3, lg: 2 }
const quarterItemGridProps = { xxxs: 12, xs: 6, md: 3, lg: 3 }
const halfItemGridProps = { xxxs: 12, xs: 6, md: 6, lg: 6 }
const fullItemGridProps = { xxxs: 12, xs: 12, md: 12, lg: 12 }
const defaultItemSx = { pb: { xxxs: 3, md: 0 }, pr: { md: 2 } }
const spacedRowItemSx = { paddingBottom: 3, pr: { md: 2 } }
const balancePanelOffset = 2.5
const balancePanelContainerSx = (theme) => ({
    width: "100%",
    [theme.breakpoints.up("lg")]: {
        // Alinha o conteúdo à quinta coluna.
        width: `calc(33% + ${theme.spacing(balancePanelOffset)})`,
        marginLeft: `-${theme.spacing(balancePanelOffset)}`,
    },
})

const createItem = (key, label, gridProps, sx = defaultItemSx) => ({
    key,
    label,
    gridProps,
    sx,
})

const companySection = {
    columns: gridColumns,
    items: [
        createItem("RazaoSocial", "Razão social", compactItemGridProps, spacedRowItemSx),
        createItem("NomeFantasia", "Nome Fantasia", compactItemGridProps, spacedRowItemSx),
        createItem("CPFCNPJ", "CNPJ", compactItemGridProps, spacedRowItemSx),
        createItem("RaizCNPJ", "Raiz CNPJ", compactItemGridProps, spacedRowItemSx),
        createItem("GrupoEconomico_Nome", "Grupo econômico", compactItemGridProps, spacedRowItemSx),
        createItem("Pais", "País", compactItemGridProps, spacedRowItemSx),
        createItem("TipoCadastro", "Tipo Cadastro", compactItemGridProps, spacedRowItemSx),
        createItem("SituacaoCadastral", "Situação Cadastral", compactItemGridProps, spacedRowItemSx),
        createItem("Setor", "Setor", compactItemGridProps, spacedRowItemSx),
        createItem("SubSetor", "Subsetor", compactItemGridProps, spacedRowItemSx),
        createItem("Site_RI", "Site RI", { xxxs: 12, xs: 12, md: 3, lg: 4 }),
        createItem("Atividade", "Atividade", fullItemGridProps, { pb: 0 }),
    ],
}

const marketSection = {
    columns: gridColumns,
    items: [
        createItem("Ticker", "Ticker B3", quarterItemGridProps),
        createItem("Setor_B3", "Setor B3", quarterItemGridProps),
        createItem("CodigoCVM", "Código CVM", quarterItemGridProps),
        createItem("SetorCVM", "Setor CVM", quarterItemGridProps, { pb: 0 }),
    ],
}

const balanceSection = {
    columns: gridColumns,
    items: [
        createItem("MesFechamento", "Mês Fechamento", halfItemGridProps),
        createItem("PeriodicidadeBalanco", "Peridiocidade Balanço", halfItemGridProps, { pb: 0 }),
    ],
}

const relatedGroupsSection = {
    columns: gridColumns,
    items: [
        createItem("GrupoAuditoria", "Grupo auditoria", compactItemGridProps, spacedRowItemSx),
        createItem("GrupoCustodiante", "Grupo custodiante", compactItemGridProps, spacedRowItemSx),
        createItem("GrupoCoordenadorLider", "Grupo coordenador lider", compactItemGridProps, spacedRowItemSx),
        createItem("GrupoFiduciario", "Grupo fiduciário", compactItemGridProps, spacedRowItemSx),
        createItem("GrupoIFRecebedora", "Grupo IF Recebedora", compactItemGridProps, spacedRowItemSx),
        createItem("GrupoSecuritizador", "Grupo Securitizador", compactItemGridProps, spacedRowItemSx),
        createItem("Observacao", "observação", fullItemGridProps, { pb: 0 }),
    ],
}

export const BoxDataCompany = ({ companyData }) => (
    <Box display="flex" flexDirection="column" gap={0.125}>
        <InfoDataPanel data={companyData} sections={[companySection]} />

        <Box
            sx={{
                display: "flex",
                flexDirection: { xxxs: "column", lg: "row" },
                gap: 0.125,
            }}
        >
            <Box sx={{ width: { xxxs: "100%", lg: "67%" } }}>
                <InfoDataPanel data={companyData} sections={[marketSection]} />
            </Box>
            <Box sx={balancePanelContainerSx}>
                <InfoDataPanel data={companyData} sections={[balanceSection]} />
            </Box>
        </Box>

        <InfoDataPanel data={companyData} sections={[relatedGroupsSection]} />
    </Box>
)

BoxDataCompany.propTypes = {
    companyData: PropTypes.shape({
        RazaoSocial: PropTypes.string,
        NomeFantasia: PropTypes.string,
        CPFCNPJ: PropTypes.string,
        RaizCNPJ: PropTypes.string,
        GrupoEconomico_Nome: PropTypes.string,
        Pais: PropTypes.string,
        TipoCadastro: PropTypes.string,
        SituacaoCadastral: PropTypes.string,
        Setor: PropTypes.string,
        SubSetor: PropTypes.string,
        Site_RI: PropTypes.string,
        Atividade: PropTypes.string,
        Ticker: PropTypes.string,
        Setor_B3: PropTypes.string,
        CodigoCVM: PropTypes.string,
        SetorCVM: PropTypes.string,
        MesFechamento: PropTypes.string,
        PeriodicidadeBalanco: PropTypes.string,
        GrupoAuditoria: PropTypes.string,
        GrupoCustodiante: PropTypes.string,
        GrupoCoordenadorLider: PropTypes.string,
        GrupoFiduciario: PropTypes.string,
        GrupoIFRecebedora: PropTypes.string,
        GrupoSecuritizador: PropTypes.string,
        Observacao: PropTypes.string,
    }),
}
